import { render, staticRenderFns } from "./ImgFallback.vue?vue&type=template&id=41abb1dc&"
import script from "./ImgFallback.vue?vue&type=script&lang=js&"
export * from "./ImgFallback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('41abb1dc')) {
      api.createRecord('41abb1dc', component.options)
    } else {
      api.reload('41abb1dc', component.options)
    }
    module.hot.accept("./ImgFallback.vue?vue&type=template&id=41abb1dc&", function () {
      api.rerender('41abb1dc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2clHv9Pe0YCnE/JS/comp/ImgFallback.vue"
export default component.exports